export default __webpack_public_path__ + "fc4e41673a13888385c684e9b4cee016.svg";